import React, { useState, useEffect } from "react";
import "./SidebarChat.css";
import { Avatar } from "@mui/material";
import { useDispatch } from "react-redux";
import { setChat } from "../../features/chatSlice";
import firestoreDB from "../../config/firebase";

function SidebarChat({ channelId, channelName }) {
  const dispatch = useDispatch();
  const [chatInfo, setChatInfo] = useState([]);

  useEffect(() => {
    firestoreDB
      .collection("Chats")
      .doc(channelId)
      .collection("messages")
      .orderBy("date", "desc")
      .onSnapshot((snapshot) =>
        setChatInfo(snapshot.docs.map((doc) => doc.data()))
      );
  }, [channelId]);

  const truncate = (string, maxLength) =>
    string?.length > maxLength ? `${string.substring(0, maxLength)}…` : string;

  return (
    <div
      onClick={() => {
        dispatch(
          setChat({
            chatId: channelId,
            chatName: channelName,
          })
        );
      }}
      className="sidebarChat"
    >
      <Avatar src="https://avatars.dicebear.com/api/human/1234d.svg" />
      <div className="sidebarChat__info">
        <h2>{channelName}</h2>
        <p>{truncate(chatInfo[0]?.msg, 20)}</p>
      </div>
    </div>
  );
}

export default SidebarChat;
